<template>
    <!-- 套餐/产品分佣-运营商 -->
    <div class="page boxs">
        <!-- 标题 -->
        <div class="titleBox flex-row ite-c">
            <b>{{topTitle.title}}</b>
            <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
            <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
        </div>

        <!-- 内容 -->
        <div v-if="showConfigPage" class="mainBox boxs">

            <create-distribution :external-info="distributionInfo"
                                 ref="createDistribution"></create-distribution>

            <!-- 分销配置-start -->
            <div class="grayTltleLine boxs" style="margin-top:24px">
                分销配置
            </div>

            <ul class="colList" v-if="this.topTitle.subTit != '分销详情'">
                <li>
                    <span class="col-tit">分佣方式</span>
                    <el-radio v-model="postForm.commission_mode"
                              label="2"
                              @change="changeCommissionMode">
                        固定金额分佣
                    </el-radio>
                    <el-radio v-model="postForm.commission_mode"
                              label="1"
                              @change="changeCommissionMode">
                        固定比例分佣
                    </el-radio>
                </li>
            </ul>

            <ul class="colList" v-if="this.topTitle.subTit == '分销详情'">
                <li>
                    <span class="col-tit">分佣方式</span>
                    <el-radio v-model="postForm.commission_mode"
                              label="2"
                              disabled
                              @change="changeCommissionMode">
                        固定金额分佣
                    </el-radio>
                    <el-radio v-model="postForm.commission_mode"
                              label="1"
                              disabled
                              @change="changeCommissionMode">
                        固定比例分佣
                    </el-radio>
                </li>
            </ul>

            <div class="botTable boxs tableTheadGray">
                <el-table :data="commissionList"
                          style="width: 561px;"
                          ref="commissionTable"
                          max-height="308"
                          border
                          fit
                          highlight-current-row
                          tooltip-effect="dark"
                          @selection-change="selsChange" 
                >
                    
                    <!-- 勾选列 -->
                    <el-table-column width="40" type="selection" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="套餐/产品名称" prop="productName" width="250" header-align="left" align="left"
                                     show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="套餐/产品金额 (元)" prop="productPrice" width="140" header-align="center" align="center"
                                     show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.productPrice/100}}
                        </template>
                    </el-table-column>

                    <el-table-column label="代理商获佣 (元)" prop="commission" width="130" header-align="center"
                                     align="center"
                                     v-if="!showPercent && this.topTitle.subTit != '分销详情'" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input class="tableInput"
                                      v-model="scope.row.commission"
                                      maxlength="8"
                            >
                            </el-input>
                        </template>
                    </el-table-column>

                    <el-table-column label="代理商获佣 (元)" prop="commission" width="130" header-align="center"
                                     align="center"
                                     v-if="!showPercent && this.topTitle.subTit == '分销详情'" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.commission}}
                        </template>
                    </el-table-column>

                    <el-table-column label="代理商获佣 (%)" prop="commission" width="130" header-align="center"
                                     align="center"
                                     v-if="showPercent && this.topTitle.subTit != '分销详情'" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input class="tableInput"
                                      v-model="scope.row.commission"
                                      maxlength="8"
                            >
                            </el-input>
                        </template>
                    </el-table-column>

                    <el-table-column label="代理商获佣 (%)" prop="commission" width="130" header-align="center"
                                     align="center"
                                     v-if="showPercent && this.topTitle.subTit == '分销详情'" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.commission}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分销配置-end -->

            <!-- 规则对象 -->
            <rule-object :external-info="distributionInfo" ref="ruleObject"></rule-object>
        </div>

        <!-- 底部按钮 -->
        <div class="botBtn" v-if="this.topTitle.subTit != '分销详情'">
            <button @click="backToList" class="butStyle whiteBtn cancelBtn">取消</button>
            <button @click="submitPostForm" :loading="submitLoading" class="butStyle pinkBtn enterBtn">确定</button>
        </div>

    </div>
</template>

<script>
    import CreateDistribution from "../components/CreateDistribution";
    import RuleObject from "../components/RuleObject";
    import {
        IsNumberNotNagtive, // 验证非负数字
        isValidNumberFormat, // 是否合法的数字格式
    } from '@/utils/validator';
    import {
        addProductPackageConfig,//添加分销配置
        updateProductPackageConfig, //编辑分销配置
        getCommissionConfig, //查询某佣金配置信息
        getEditCommissionConfig, //编辑查询分销配置
        getAddCommissionConfig, //添加查询分销配置
        generateId, //生成配置id
        existsWdConfig, //校验代理商是否有配置过网点佣金
    } from '@/api/DistributionList/distributionList.js';
    // 表单数据
    const defaultPostForm = {
        dcCommissionConfig: {},
        dcCommissionCfgCptcList: []
    };

    export default {
        name: 'PackageProductCommission',
        data() {
            return {
                //标题
                topTitle: {
                    title: '分销列表',
                    subTit: '',
                    thirdTit: '',
                },
                data: null,
                optionalParams: null,
                // 传递组件的数据
                distributionInfo: null,
                // 表单数据
                postForm: Object.assign({}, defaultPostForm),
                submitLoading: false,
                showPercent: false, //代理商获佣单位改为百分比（%）
                showConfigPage: false,

                // 分销配置的表格勾选数组
                sels: [],
                // 分销配置的表格
                commissionList: [],

            }
        },
        components: {
            CreateDistribution, // 创建分销
            RuleObject, // 规则对象
        },
        computed: {},
        created() {
            // 获取上级页面携带的参数
            this.initData();
        },
        methods: {
            // 获取上级页面携带的参数
            initData() {

                this.optionalParams = this.$route.query;
                // console.log('optionalParams', this.optionalParams);
                this.topTitle.subTit = this.optionalParams.subTit;
                this.data = this.optionalParams.data;
                if (this.optionalParams.operate == 'add') {
                    this.postForm.commission_mode = "2";
                    this.showConfigPage = true;
                    this.getAddCommissionConfig();
                }
                if (this.optionalParams.operate == 'edit' || this.optionalParams.operate == 'show') {
                    this.postForm.id = this.data.id;
                    this.postForm.dcCommissionConfig.id = this.optionalParams.id;
                    // 当前会员类型：运营商(operator)或代理商
                    this.memberType = this.optionalParams.memberType;
                    this.getCommissionConfig();

                }
            },
            // 添加查询分销配置
            async getAddCommissionConfig() {
                try {
                    const result = await getAddCommissionConfig({});
                    this.commissionList = result.data;
                } catch (e) {
                    console.log(e)
                }
            },
            // 查询某佣金配置信息
            async getCommissionConfig() {
                try {
                    const result = await getCommissionConfig({"configId": this.data.id});
                    this.distributionInfo = result.data;
                    this.postForm.commission_mode = String(result.data.calcMethod.value);
                    this.initChangeCommissionMode();
                    this.getEditCommissionConfig();
                    // 声明子组件的addMemberIds,不然编辑分销时勾选会员会报错
                    this.distributionInfo.addMemberIds = []
                } catch (e) {
                    console.log(e)
                }
            },
            // 查询当前登录会员对应某规则的佣金配置额度
            async getEditCommissionConfig() {
                try {
                    const result = await getEditCommissionConfig({"ruleId": this.data.ruleId, "id": this.data.id});
                    this.commissionList = result.data;
                    if (this.postForm.commission_mode == '2') {
                        this.commissionList.filter(items => {
                            items.commission = items.commission / 100;
                        })
                    }

                    // 当前需要勾选的数据的数组
                    let checkedGouArr = []
                    this.commissionList.forEach(item => {
                        if(item.ischeck == '2') {
                            checkedGouArr.push(item)
                            // console.log('checkedGouArr-push', checkedGouArr)
                        }
                    })
                    // 显示勾选分销配置表格行事件
                    this.$nextTick(() => {
                        if(checkedGouArr) {
                            checkedGouArr.forEach(row => {
                                this.$refs.commissionTable.toggleRowSelection(row, true);
                            });
                        } else {
                            // this.$refs.commissionTable.clearSelection();
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            // 生成配置id
            async generateId() {
                generateId({})
                    .then(resp => {
                        this.postForm.dcCommissionConfig.id = resp.data;
                        // 提交之前重新组装下请求对象
                        this.assembleForm();
                        // 校验表单
                        if (this.verifyPostForm()) {
                            this.addProductPackageConfig();
                        }
                    })
                    .catch(e => console.log(e));
            },
            // 返回分销列表页
            backToList() {
                this.$router.push('distributionListIndex')
            },
            // 分佣方式初始获取
            initChangeCommissionMode() {
                // 固定金额分佣
                if (this.postForm.commission_mode == '2') {
                    this.showPercent = false;
                }
                // 固定比例分佣
                if (this.postForm.commission_mode == '1') {
                    this.showPercent = true;
                }
                this.showConfigPage = true;
            },
            // 分佣方式改变
            async changeCommissionMode() {
                // 如果当前是运营商，要先判断下级代理商是否有配置规则，没有才能切换分佣方式
                if(this.memberType == 'operator') {
                    // 校验代理商是否有配置过网点佣金
                    try {
                        const result = await existsWdConfig({"configId": this.data.id, "ruleId": this.data.ruleId});
                        let hasWdConfig = result.data;
                        if(hasWdConfig == true) {
                            this.$message.warning('网点正在使用当前分销规则，暂时不能编辑。')
                            return false;
                        }
                    } catch (e) {
                        console.log(e)
                    }
                }

                // 固定金额分佣
                if (this.postForm.commission_mode == '2') {
                    this.showPercent = false;
                }
                // 固定比例分佣
                if (this.postForm.commission_mode == '1') {
                    this.showPercent = true;
                }
                this.showConfigPage = true;
            },
            // 列表勾选(当选择项发生变化时会触发该事件)
            selsChange (val) {
                this.sels = val
                // console.log('selsChange-val', val)
            },
            submitPostForm() {
                this.submitLoading = true;

                //如果有id就编辑，没就添加
                if (!this.postForm.id) {
                    this.generateId();
                }else{
                    // 提交之前重新组装下请求对象
                    this.assembleForm();
                    // 校验表单
                    if (this.verifyPostForm()) {
                            this.postForm.dcCommissionConfig.id = this.postForm.id;
                            this.postForm.dcCommissionCfgCptcList.filter(items => {
                                items.configId = this.postForm.id;
                            });
                            // console.log(this.postForm);
                            updateProductPackageConfig(this.postForm)
                                .then(resp => {
                                    this.$notifySuccess('分销编辑成功')
                                    this.submitLoading = false
                                    this.$router.push('distributionListIndex')
                                })
                                .catch(e => console.log(e))
                    
                    }
                }
                
            },
            addProductPackageConfig() {
                // console.log(this.$refs.ruleObject.distributionInfo);
                if (this.$refs.ruleObject.distributionInfo.memberSize > 0) {
                    //添加配置对象
                    this.$refs.ruleObject.addMemberEvent(this.postForm.dcCommissionConfig.id);
                }

                // console.log(this.postForm);
                //添加配置
                addProductPackageConfig(this.postForm)
                    .then(resp => {
                        this.$notifySuccess('分销添加成功')
                        this.submitLoading = false
                        this.$router.push('distributionListIndex')
                    })
                    .catch(e => console.log(e));
            },
            // 提交按钮的校验
            verifyPostForm() {
                if (!this.postForm.dcCommissionConfig.name) {
                    this.$notifyError("请输入分销名称");
                    return false;
                }

                // 固定金额分佣、固定比例分佣
                let indexArr = [];
                let indexArr2 = [];
                for (let i = 0; i < this.commissionList.length; i++) {

                    // 如果勾选数组里面存在当前项this.commissionList[i]，进入判断
                    if(JSON.stringify(this.sels).indexOf(JSON.stringify(this.commissionList[i])) != -1){
                        // 代理商获佣
                        let commission = this.commissionList[i].commission

                        // 判断commission非空
                        let a = (JSON.stringify(commission) == "{}");
                        if (a == true || commission == '' || commission == "" || commission == null) {
                            indexArr.push(i + 1)
                            break;
                        }
                        // 判断commission符合‘正数，最多保留2位小数’
                        if (!IsNumberNotNagtive(commission)) {
                            indexArr2.push(i + 1)
                            break;
                        }
                    }

                    
                }
                if (indexArr.length > 0) {
                    this.$notifyError("请补充分销配置表第" + indexArr + "行的代理商获佣");
                    return false;
                }
                if (indexArr2.length > 0) {
                    this.$notifyError("请修改分销配置表第" + indexArr2 + "行的代理商获佣符合‘正数，最多保留2位小数’");
                    return false;
                }

                // 固定金额分佣时
                if (this.showPercent == false) {
                    let indexArr3 = [];
                    for (let i = 0; i < this.commissionList.length; i++) {

                        // 代理商获佣 (元)
                        let commission = this.commissionList[i].commission
                        let productPrice = this.commissionList[i].productPrice
                        // 判断commission不能大于套餐/产品金额productPrice
                        if (parseFloat(commission) > parseFloat(productPrice)) {
                            indexArr3.push(i + 1)
                            break;
                        }

                    }
                    // if (indexArr3.length > 0) {
                    //     this.$notifyError("分销配置表第" + indexArr3 + "行的代理商获佣不能大于套餐/产品金额");
                    //     return false;
                    // }
                }
                // 固定比例分佣时
                if (this.showPercent == true) {
                    let indexArr4 = [];
                    for (let i = 0; i < this.commissionList.length; i++) {

                        // 代理商获佣 (%)
                        let commission = this.commissionList[i].commission
                        // 判断大于0小于100
                        if (parseFloat(commission) > 100) {
                            indexArr4.push(i + 1)
                            break;
                        }

                    }
                    if (indexArr4.length > 0) {
                        this.$notifyError("分销配置表第" + indexArr4 + "行的代理商获佣不能大于100");
                        return false;
                    }
                }

                // if (this.optionalParams.operate == 'add') {
                //     if (this.$refs.ruleObject.distributionInfo.memberSize == 0) {
                //         this.$notifyError("请配置规则对象");
                //         return false;
                //     }
                // }

                return true;
            },
            // 提交之前重新组装下请求对象
            assembleForm() {
                // 创建分销的参数
                let createDistribution = this.$refs.createDistribution.distributionInfo;
                // console.log(createDistribution);
                this.postForm.dcCommissionConfig.name = createDistribution.name;
                this.postForm.dcCommissionConfig.ruleId = this.data.ruleId;
                this.postForm.dcCommissionConfig.settlementType = parseInt(createDistribution.settle_accounts_way);
                this.postForm.dcCommissionConfig.calcMethod = parseInt(this.postForm.commission_mode);

                // 勾选的分销配置
                const sels = JSON.parse(JSON.stringify(this.sels));
                sels.forEach(item => {
                    // console.log(this.postForm.dcCommissionConfig.calcMethod);
                    if (this.postForm.dcCommissionConfig.calcMethod == 2) {
                        let currentRowParam = {
                            productId: item.productId,
                            productName: item.productName,
                            configId:this.postForm.dcCommissionConfig.id,
                            productId:item.productId,
                            productPrice:item.productPrice,
                            commission:item.commission*100,
                            taxRate:item.taxRate
                        }

                        let currIndex = JSON.stringify(this.postForm.dcCommissionCfgCptcList).indexOf(JSON.stringify(currentRowParam))
                        if(currIndex == -1){
                            // 勾选的分销配置
                            this.postForm.dcCommissionCfgCptcList.push(currentRowParam)
                        }
                    }else{
                        let currentRowParam = {
                            productId: item.productId,
                            productName: item.productName,
                            configId:this.postForm.dcCommissionConfig.id,
                            productId:item.productId,
                            productPrice:item.productPrice,
                            commission:item.commission,
                            taxRate:item.taxRate
                        }

                        let currIndex = JSON.stringify(this.postForm.dcCommissionCfgCptcList).indexOf(JSON.stringify(currentRowParam))
                        if(currIndex == -1){
                            // 勾选的分销配置
                            this.postForm.dcCommissionCfgCptcList.push(currentRowParam)
                        }
                    }
                });
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .page {
        width: 100%;
        // SrHeader(height:48px), SrMain(padding: 13px 10px 10px;)
        min-height: calc(100% - 48px - 13px - 10px);
        padding-bottom: 30px;
        background: #ffffff;
    }

    // 标题
    .titleBox {
        width: 100%;
        background: #ffffff;
        height: 44px;
        padding: 0 9px;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    .titleBox b {
        color: #2B2727;
        font-size: 15px;
    }

    .titleBox span {
        color: #7F7F7F;
        font-size: 13px;
    }

    .titleBox .titRiImg {
        width: 76px;
        height: 24px;
    }


    .mainBox {
        padding: 0 15px 32px 12px;
    }

    /* 取消确定按键 */
    .cancelBtn {
        margin-right: 20px;
    }


    /* 行列 */
    .colList > li {
        margin-top: 20px;
    }

    .colList > li + li {
        margin-top: 20px;
    }

    .colList li > .col-tit {
        display: inline-block;
        width: 60px;
        font-size: 12px;
        font-weight: bold;
        color: #B7B2AF;
        margin-right: 14px;
        text-align: right;
    }

    .col-tit > i {
        font-style: normal;
        color: #DF0000;
    }

    // 表格
    .botTable {
        margin-top: 20px;
        padding-left: 14px;
        width: 100%;
    }

    .tableInput {
        width: 100%;
        outline: none;
    }

    .tableInput input {
        text-align: center;
    }
</style>
